import { QarepaEnumInformation } from '@qarepa/common';

export enum AbsenceStatusEnum {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type AbsenceStatusType =
  | AbsenceStatusEnum.CREATED
  | AbsenceStatusEnum.ACTIVE
  | AbsenceStatusEnum.INACTIVE;

export const AbsenceStatusArray = [
  AbsenceStatusEnum.CREATED,
  AbsenceStatusEnum.ACTIVE,
  AbsenceStatusEnum.INACTIVE,
];

export const AbsenceStatusInfo: QarepaEnumInformation<AbsenceStatusEnum> = {
  [AbsenceStatusEnum.CREATED]: {
    name: $localize`Creado`,
  },

  [AbsenceStatusEnum.ACTIVE]: {
    name: $localize`Activo`,
  },

  [AbsenceStatusEnum.INACTIVE]: {
    name: $localize`Inactivo`,
  },
};
